import ajax from '../ajax'

// 模型图片移动
// export function changePSImgApi(data) {
//     return ajax({
//         method:'post',
//         url: 'v2/ps/changeProcess',
//         data
//     })
// }

  //ERP 员工table数据 /api/staff/search
export function  ERPStaffApi(params) {
    return ajax({
        method:'get',
        url: 'api/staff/index',
        params
    })
}
 //ERP 员工table所属部门数据 /api/staff/search
export function  ERPSearchApi(params) {
    return ajax({
        method:'get',
        url: 'api/staff/search',
        params
    })
}


///api/income/edit
export function  EditApi(data) {
    return ajax({
        method:'post',
        url: 'api/income/edit',
        data
    })
}




//api/income/info?id=2
export function  IncomeApi(params) {
    return ajax({
        method:'get',
        url: 'api/income/info',
        params
    })
}


//筛选客户/api/income/customer?name=2
export function CustomerApi(params) {
    return ajax({
        method:'get',
        url: 'api/income/customer',
        params
    })
}


//排除客户/api/income/project?

export function ProjectApi(params) {
    return ajax({
        method:'get',
        url: 'api/income/project',
        params
    })
}



//指认金额  /api/income/identify

export function IdentifyApi(data) {
    return ajax({
        method:'post',
        url: 'api/income/identify',
        data
    })
}


///api/income/identifydel

export function IdentifydelApi(data) {
    return ajax({
        method:'post',
        url: 'api/income/identifydel',
        data
    })
}









// /api/customer/index 客户管理列表

export function  ERPCustomerApi(params) {
    return ajax({
        method:'get',
        url: 'api/customer/index',
        params
    })
}


///  客户顶部查询数据 api/customer/search
export function  ERPCutApi(params) {
    return ajax({
        method:'get',
        url: 'api/customer/search',
        params
    })
}




///  支出管理查询数据  api/expenditure/index
export function  ERPExpApi(params) {
    return ajax({
        method:'get',
        url: 'api/expenditure/index',
        params
    })
}

 //api/expenditure/search
export function  ERPExpTuApi(params) {
    return ajax({
        method:'get',
        url: 'api/expenditure/search',
        params
    })
}




//收入管理 /api/income/index

export function  ERPIncomeApi(params) {
    return ajax({
        method:'get',
        url: 'api/income/index',
        params
    })
}


/// 搜索 api/income/search

export function  ERPIcmApi(params) {
    return ajax({
        method:'get',
        url: 'api/income/search',
        params
    })
}


//指向明细/api/income/identifies
export function  ERPidentifiesApi(params) {
    return ajax({
        method:'get',
        url: 'api/income/identifies',
        params
    })
}



//支出管理 /api/expenditure/info?id=9473
export function  InfoApi(params) {
    return ajax({
        method:'get',
        url: 'api/expenditure/info',
        params
    })
}


// 保存 /api/expenditure/edit
export function  EditTwoApi(data) {
    return ajax({
        method:'post',
        url: 'api/expenditure/edit',
        data
    })
}







//api/customer/info

export function  InfoTwoApi(params) {
    return ajax({
        method:'get',
        url: 'api/customer/info',
        params
    })
}


///api/customer/edit
export function  editTwoApi(data) {
    return ajax({
        method:'post',
        url: 'api/customer/edit',
        data
    })
}





//员工管理 /api/staff/info
export function  InfoThreeApi(params) {
    return ajax({
        method:'get',
        url: 'api/staff/info',
        params
    })
}


///api/staff/edit  保存
export function EditThreeApi(data) {
    return ajax({
        method:'post',
        url: 'api/staff/edit',
        data
    })
}


//删除/api/income/del 删除收入id
export function DelApi(data) {
    return ajax({
        method:'post',
        url: 'api/income/del',
        data
    })
}

//删除/api/expenditure/del 支出删除id
export function ExpeDelApi(data) {
    return ajax({
        method:'post',
        url: 'api/expenditure/del',
        data
    })
}

//删除/api/customer/del 客户管理删除id
export function CustDelApi(data) {
    return ajax({
        method:'post',
        url: 'api/customer/del',
        data
    })
}

//删除/api/staff/del 员工管理删除id
export function StaffDelApi(data) {
    return ajax({
        method:'post',
        url: 'api/staff/del',
        data
    })
}




// WEBPACK FOOTER //
// ./src/api/staff/staff.js